import * as React from 'react';
import { ChevronDown } from 'lucide-react';
import { FieldLabel } from 'features/DigitalMarketing/components/FormControls';
import {
  editWebsiteContentInputClassName,
  editWebsiteContentLabelClassName,
} from 'features/DigitalMarketing/constants/formStyles';
import { DMDiv, DMSelect, DMOption } from '../Primitives';

type OptionItem = string | { label: string; value: string | number };

type DMSelectFieldProps = {
  label: string;
  name: string;
  value: string | number;
  placeholder: string;
  options: OptionItem[];
  required?: boolean;
  showChevron?: boolean;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLSelectElement>) => void;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
};

const getOptionLabel = (option: OptionItem): string =>
  typeof option === 'string' ? option : option.label;

const getOptionValue = (option: OptionItem): string | number =>
  typeof option === 'string' ? option : option.value;

export const DMSelectField = ({
  label,
  name,
  value,
  placeholder,
  options,
  required = false,
  showChevron = true,
  onChange,
  onBlur,
  className = '',
  inputClassName,
  labelClassName,
}: DMSelectFieldProps) => (
  <DMDiv className={className}>
    <FieldLabel
      className={labelClassName || editWebsiteContentLabelClassName}
      required={required}
    >
      {label}
    </FieldLabel>
    <DMDiv className="relative">
      <DMSelect
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={`${
          inputClassName || editWebsiteContentInputClassName
        } appearance-none pr-[3vw] ${
          value ? 'text-gray-950' : 'text-gray-400'
        }`}
      >
        <DMOption value="" disabled>
          {placeholder}
        </DMOption>
        {options.map(option => {
          const optionLabel = getOptionLabel(option);
          const optionValue = getOptionValue(option);

          return (
            <DMOption key={optionValue} value={optionValue}>
              {optionLabel}
            </DMOption>
          );
        })}
      </DMSelect>
      {showChevron && (
        <ChevronDown
          className="pointer-events-none absolute right-[1vw] top-1/2 h-[2.2vh] w-[2.2vh] -translate-y-1/2 text-gray-950"
          strokeWidth={2}
        />
      )}
    </DMDiv>
  </DMDiv>
);
